import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  deleteToken,
} from "firebase/messaging";
import AuthService from "./auth.service";

const FireBaseService = () => {
  const { updateFCMService } = AuthService();
  const firebaseConfig = {
    apiKey: "AIzaSyCxECgnwUDP0QysCiy6CIQ0iM5B2CX3BQ8",
    authDomain: "find-my-doctor-abbf5.firebaseapp.com",
    projectId: "find-my-doctor-abbf5",
    storageBucket: "find-my-doctor-abbf5.firebasestorage.app",
    messagingSenderId: "922533426430",
    appId: "1:922533426430:web:6d24ef8d794f14ab38e1af",
    measurementId: "G-407HGFDVXP",
  };

  const app = initializeApp(firebaseConfig);
  const messaging = getMessaging(app);

  const requestFirebaseNotificationPermission = async (barerToken) => {
    try {
      const registration = await navigator.serviceWorker.register(
        "/firebase-messaging-sw.js",
      );

      await deleteToken(messaging);

      const token = await getToken(messaging, {
        vapidKey:
          "BN8DKjvfKuNBSUe9qMWR7YTghw7oyfL904pxZyJJeAl77efvhBUjJJACzl0wcQ8lta2Ift4STL-FdCEh7LJwREE",
        serviceWorkerRegistration: registration,
      });

      if (token) {
        await updateFCMService(barerToken, token);
        return token;
      } else {
        console.warn("No registration token available.");
        return null;
      }
    } catch (err) {
      console.error("An error occurred while retrieving token.", err);
      return null;
    }
  };

  const onMessageListener = () =>
    new Promise((resolve) => {
      onMessage(messaging, (payload) => {
        resolve(payload);
      });
    });

  return { requestFirebaseNotificationPermission, onMessageListener };
};

export default FireBaseService;
